import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllInboxes = createAsyncThunk('notificationInbox/getAllInboxes', async (payload, thunkAPI) => {
  const { limit = 6, page = 1 } = payload;
  try {
    const response = await axiosInstance.get(`/inboxes?limit=${limit}&page=${page}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getInboxDetail = createAsyncThunk('notificationInbox/getInboxDetail', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/inboxes/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getUnreadNotificationCount = createAsyncThunk(
  'notificationInbox/getUnreadNotificationCount',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/inboxes/total-unread`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getUnreadMessage = createAsyncThunk('notificationInbox/getUnreadMessage', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `/inbox/total-unread?room_types=cs-order&room_types=cs-customer&room_types=cs-driver`,
    );
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
